function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4 8a3.87 3.87 0 01-1.55-.315 4.057 4.057 0 01-1.275-.86 4.057 4.057 0 01-.86-1.275A3.87 3.87 0 010 4c0-.553.105-1.072.315-1.555A4.057 4.057 0 012.45.315 3.87 3.87 0 014 0c.113 0 .208.038.285.115A.387.387 0 014.4.4a.387.387 0 01-.115.285A.387.387 0 014 .8c-.887 0-1.642.312-2.265.935A3.085 3.085 0 00.8 4c0 .887.312 1.642.935 2.265A3.085 3.085 0 004 7.2c.887 0 1.642-.312 2.265-.935A3.085 3.085 0 007.2 4c0-.113.038-.208.115-.285A.387.387 0 017.6 3.6c.113 0 .208.038.285.115A.387.387 0 018 4a3.87 3.87 0 01-.315 1.55 4.057 4.057 0 01-2.13 2.135A3.86 3.86 0 014 8z",
  fill: "#ACB5C2"
});
function SvgProgressActivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 8 8",
    fill: "none"
  }, props), _ref);
}
export default __webpack_public_path__ + "fonts/progress-activity-8545d6ebaf785abddb3c3fb0e73388ef.svg";
export { SvgProgressActivity as ReactComponent };